import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../../../../context/LanguageContext';
import { workshopServices } from '../../data/WorkshopData';
import '../style/workshop.css';

const WorkshopSection: React.FC = () => {
    const { t, getTranslation, language } = useLanguage();
    const translation = t as any;
    const services = translation.SERVICES || {};
    const readMoreText = getTranslation('BUTTONS.readMore') || (language === 'pt' ? 'Ler Mais' : 'Read More');

    return (
        <>
            {/* Page Header */}
            <section className="page-header">
                <div
                    className="page-header__bg"
                    style={{
                        backgroundImage: 'url(/assets/logo/workshop/workshop_2.webp)',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        height: '380px'
                    }}
                ></div>
                <div className="container">
                    <div className="page-header__inner">
                        <div className="page-header__img-1">
                            <img
                                src="/assets/logo/workshop/workshop_1.webp"
                                alt="Roady Oliveira de Azeméis Workshop"
                                style={{ width: '250px', height: '300px', objectFit: 'contain' }}
                            />
                        </div>
                        <h3>{t.NAVIGATION?.workshop || 'Workshop'}</h3>
                        <div className="thm-breadcrumb__inner">
                            <ul className="thm-breadcrumb list-unstyled">
                                <li><a href="/">{t.NAVIGATION?.start || 'Home'}</a></li>
                                <li><span className="fas fa-angle-right"></span></li>
                                <li>{t.NAVIGATION?.workshop || 'Workshop'}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services Grid */}
            <section className="services-page">
                <div className="container">
                    <div className="workshop-intro">
                        <h1 className="workshop-intro__title">
                            {language === 'pt'
                                ? <>Oficina Automóvel em Oliveira de Azeméis<br />Todos os Serviços num Só Local</>
                                : <>Car Workshop in Oliveira de Azeméis<br />All Services in One Place</>}
                        </h1>
                        <p className="workshop-intro__description">
                            {language === 'pt'
                                ? 'No Roady Oliveira de Azeméis encontra serviços de oficina automóvel para manutenção, revisão e reparação do seu carro. Da mudança de óleo aos travões e do diagnóstico eletrónico à revisão automóvel, conte com uma equipa preparada para identificar o problema e encontrar a solução adequada.'
                                : 'At Roady Oliveira de Azeméis you will find car workshop services for the maintenance, servicing and repair of your car. From oil changes to brakes and from electronic diagnostics to car servicing, count on a team prepared to identify the problem and find the right solution.'}
                        </p>
                    </div>
                    <div className="row">
                        {workshopServices.map((service) => (
                            <div key={service.id} className="col-xl-4 col-lg-4 col-md-6">
                                <Link to={service.link} className="services-one__single services-one__single--clickable">
                                    <div className="services-one__img-box">
                                        <div className="services-one__img">
                                            <img
                                                src={service.image}
                                                alt={services[service.titleKey] || service.titleKey}
                                                style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                            />
                                        </div>
                                        <div className="services-one__count">
                                            {String(service.id).padStart(2, '0')}
                                        </div>
                                    </div>
                                    <div className="services-one__content">
                                        <div className="services-one__icon">
                                            <span className={service.icon}></span>
                                        </div>
                                        <h2 className="services-one__title">
                                            <span>
                                                {services[service.titleKey] || service.titleKey}
                                            </span>
                                        </h2>
                                        <p className="services-one__text">
                                            {service.cardDesc[language === 'pt' ? 'pt' : 'en']}
                                        </p>
                                        <div className="services-one__btn-box">
                                            <span>
                                                {readMoreText}
                                                <span className="icon-next"></span>
                                            </span>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

        </>
    );
};

export default WorkshopSection;

